import { render } from "./LeaveAssignConfirmModal.vue?vue&type=template&id=54b79656&scoped=true"
import script from "./LeaveAssignConfirmModal.vue?vue&type=script&lang=js"
export * from "./LeaveAssignConfirmModal.vue?vue&type=script&lang=js"

import "./LeaveAssignConfirmModal.vue?vue&type=style&index=0&id=54b79656&scoped=true&lang=css"

import exportComponent from "../../../../../../orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b79656"]])

export default __exports__